import { API_BASE_URL } from "@/config";
import { validateToken } from '@/utils/auth';
import CustomTable from '@/components/CustomTable/CustomTable.vue';
import CustomTabs from '@/components/CustomTab/CustomTab.vue';
import { useToast } from "@/components/Toast/useToast";

const STATUS_MAP = {
  Pending: 'pending',
  Approved: 'approved',
  Declined: 'declined'
};

export default {
    name: 'ClientRequestedServices',
    setup() {
      const { showSuccess, showError } = useToast();
      
      return {
        showSuccess,
        showError
      };
    },
    components: {
      CustomTable,
      CustomTabs
    },

    data: () => ({
      currentTab: localStorage.getItem('client_requested_servicesTab') || 'Approved',
      approved_requests: [],
      pending_requests: [],
      declined_requests: [],
      columns: [
        { label: 'Service Name', key: 'service_name' },
      ],
      tabs: [
        { label: 'Approved', value: 'Approved' },
        { label: 'Pending', value: 'Pending' },
        { label: 'Declined', value: 'Declined' }
      ]
    }),
    watch: {
      currentTab(newTab) {
        localStorage.setItem('client_requested_servicesTab', newTab)
        localStorage.removeItem(`page_requested_services_${newTab}`);
      }
    },

    computed: {
      client_id() {
        return this.$store.getters.get_client_id;
      }
    },

    methods: {
      view_services_requested(page = 1, search = '') {
        const TOKEN = localStorage.getItem('token');
        const status = STATUS_MAP[this.currentTab];
        return new Promise((resolve, reject) => {
          let url = `${API_BASE_URL}/verify_api/verify_admin_api/view_requested_services/${this.client_id}?page=${page}&status=${status}`;
          if (search) {
            url += `&search=${encodeURIComponent(search)}`;
          }
          $.ajax({
            url,
            method: 'GET',
            dataType: 'json',
            headers: { Authorization: `Token ${TOKEN}` },
            success: function (data) {
              resolve({
                count: data.count,
                results: data.results,
              });
            },
            error: function (xhr, status, error) {
              reject(error);
            }
          });
        });
      },
      action_service_requested(service_id,application_id,action){
        const TOKEN = localStorage.getItem('token');
        const ACTION_APPLICATION_URL = `${API_BASE_URL}/verify_api/verify_admin_api/action_service_requested/`;
  
        $.ajax({
          url: ACTION_APPLICATION_URL,
          method: 'POST',
          contentType: 'application/json',
          headers: {
            Authorization: `Token ${TOKEN}`
          },
          data: JSON.stringify({
            service_id: service_id,
            action: action,
            application_id:application_id
          }),
          success: (response) => {
            this.showSuccess(response.message);
            setTimeout(() => {
              window.location.reload();
            }, 1500);
          },
          error: (response) => {
            this.showError(response.responseJSON?.error || 'An error occurred while processing the application.');
          }
        });
      },


    },

    mounted() {
      if (!validateToken(this.$router)) {
          return;
      }
      this.view_services_requested();
    }    
};
